@if (productList$ | async; as productList) {
  <section class="product-refinement">
    <section class="header">
      <aside aria-label="Product Category" class="content content-left">
        @if (false) {
          <section class="selectBox">
            <b>{{ 'plp.category' | cxTranslate }}</b>
            <ng-select
              [items]="categoryFormat"
              bindLabel="name"
              bindValue="value"
              [multiple]="false"
              name="selectedCategory"
              placeholder="Select Category"
            [(ngModel)]="selectedCategory"></ng-select>
          </section>
        }
      </aside>
    </section>
    <section class="main">
      <aside aria-label="Product Filterby" class="content content-left">
        @if (facets$?.length > 0) {
          <section class="title">
            <section class="filterByTitle-main">
              {{ 'plp.filterby' | cxTranslate }}
            </section>
            @for (facet of facets$; track facet) {
              <cx-facet
                class="facets"
                #facetRef
              [facet]="facet"></cx-facet>
            }
          </section>
        }
        @if (
          productList?.products?.length == 0 &&
          productList?.freeTextSearch?.length > 0
          ) {
          <section
            class="title"
            >
            <section class="filterByTitle-main explorer">
              {{ 'plp.explore' | cxTranslate }}
            </section>
            @if (userDetails != undefined) {
              <ul class="explore-list">
                <li>
                  <a href="/dz/fr_DZ/DZD/Open-Catalogue/c/1" class="products-link">
                    {{ 'plp.exploreProducts' | cxTranslate | titlecase }}
                  </a>
                </li>
                <li>
                  <a href="/dz/fr_DZ/DZD/Open-Catalogue/c/1" class="products-link">
                    {{ 'plp.exploreInfluenza' | cxTranslate | titlecase }}
                  </a>
                </li>
                <li>
                  <a href="/dz/fr_DZ/DZD/Open-Catalogue/c/1" class="products-link">
                    {{ 'plp.exploreSavedOrders' | cxTranslate | titlecase }}
                  </a>
                </li>
              </ul>
            }
            @if (userDetails == undefined) {
              <section>
                <a href="/dz/fr_DZ/DZD/Open-Catalogue/c/1" class="products-link">
                  {{ 'plp.products' | cxTranslate | titlecase }}
                </a>
              </section>
            }
          </section>
        }
      </aside>
    </section>
    <ng-template #facetsRwd>
      <section class="modal-class">
        <section class="modal-heading">
          <h2>
            <span class="close-icon" aria-hidden="true" (click)="hide()">
              &times;
            </span>
          </h2>
          <h2 class="select-heading">
            {{ 'plp.selectRefinement' | cxTranslate }}
          </h2>
        </section>
        @if (
          productList?.products?.length > 0 ||
          productList?.freeTextSearch?.length == 0) {
          <section
            class="filterByTitle-main"
            >
            {{ 'plp.filterby' | cxTranslate }}
          </section>
        } @else {
          <section class="filterByTitle-main explore-refine">
            {{ 'plp.explore' | cxTranslate }}
          </section>
        }
        <ng-template #noProductsExplorer>
          <section class="filterByTitle-main explore-refine">
            {{ 'plp.explore' | cxTranslate }}
          </section>
        </ng-template>
        <section class="facets">
          @for (facet of facets$; track facet) {
            <cx-facet
              class="facets"
              #facetRef
            [facet]="facet"></cx-facet>
          }
        </section>
        <span id="clearAll-filters">
          @if (
            productList?.products?.length > 0 ||
            productList?.freeTextSearch?.length == 0) {
            <a
              href="/dz/fr_DZ/DZD/Open-Catalogue/c/1"
              data-di-id="di-id-37774359-a6b0cba1"
              >
              {{ 'plp.clearFliter' | cxTranslate }}
            </a>
          } @else {
            <a
              href="/dz/fr_DZ/DZD/Open-Catalogue/c/1"
              class="float-left products-link">
              {{ 'plp.products' | cxTranslate | titlecase }}
            </a>
          }
          <ng-template #noProducts>
            <a
              href="/dz/fr_DZ/DZD/Open-Catalogue/c/1"
              class="float-left products-link">
              {{ 'plp.products' | cxTranslate | titlecase }}
            </a>
          </ng-template>
        </span>
      </section>
    </ng-template>
    <button
      class="btn btn-default"
      id="refineBtn"
      data-di-id="#refineBtn"
      (click)="refine()">
      {{ 'plp.refineButton' | cxTranslate }}
      @if (activefacets) {
        <span class="activeclass">({{ activefacets }})</span>
      }
      <span></span>
    </button>
  </section>
}
